// extracted by mini-css-extract-plugin
export var icon = "_4l-1";
export var subtext = "_4l-0";